import { createContext, useContext } from 'react';

export const FeatureFlagToggleContext = createContext({
  id: '',
  isLoading: false,
  isEnabled: false,
  isProcessing: false,
  onModalOpen: () => {}
});

export const useFeatureToggle = () => useContext(FeatureFlagToggleContext);
